import React from 'react';
function Embed({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        d="M12 13V4M12 13l3-3M12 13l-3-3M16.5 7H19c1 0 2 1 2 2v8c0 1-1 2-2 2H5c-1 0-2-1-2-2V9c0-1 1-2 2-2h2.5"
      />
    </svg>
  );
}

export default Embed;
